module.exports = __webpack_public_path__ + "img/sprouting.921b75ca.png";